import { render } from "./ContainerInfo.component.vue?vue&type=template&id=481e8b06&ts=true"
import script from "./ContainerInfo.component.vue?vue&type=script&lang=ts"
export * from "./ContainerInfo.component.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__